import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';

const AddRawMaterialSubCat = ({ show, onClose,onUpdated }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [selectedOption, setSelectedOption] = useState(null);
  const [categories, setCategories] = useState([]);
  const [subcategoryName, setSubcategoryName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  // ✅ Fetch categories from Laravel API
  useEffect(() => {
    if (show) {
      axios.get(`${baseURL}/list/active`)
        .then((res) => {
          const options = res.data.map((cat) => ({
            value: cat.sno,
            label: cat.rawmaterialcategory_name
          }));
          setCategories(options);
        })
        .catch((err) => console.error("Error fetching categories:", err));
    }
  }, [show]);

  // ✅ Handle form submission
//   const handleCreate = async () => {
//     if (!selectedOption || !subcategoryName.trim()) {
//       alert("Please fill all required fields!");
//       return;
//     }

//     setLoading(true);
//     try {
//       const payload = {
//         subcategory_name: subcategoryName,
//         rawmaterial_category_sno: selectedOption.value,
//         description: description,
//       };

//       const res = await axios.post(`${baseURL}/rawmaterial-sub/store`, payload);

//       if (res.data.success) {
//         // alert("Subcategory created successfully!");
//         onClose();
//       }
//     } catch (error) {
//       console.error("Error creating subcategory:", error);
//     //   alert("Failed to create subcategory.");
//     } finally {
//       setLoading(false);
//     }
//   };

const handleCreate = async () => {
  if (!selectedOption || !subcategoryName.trim()) {
    alert("Please fill all required fields!");
    return;
  }

  setLoading(true);
  try {
    const payload = {
      subcategory_name: subcategoryName,
      rawmaterial_category_sno: selectedOption.value,
      description: description,
    };

    const res = await axios.post(`${baseURL}/rawmaterial-sub/store`, payload);

    if (res.data.success) {
      // ✅ Optional: show a success message
      // alert("Subcategory created successfully!");

      // ✅ Trigger soft reload via callback (refresh list in parent)
      if (typeof onUpdated === "function") {
        await onUpdated();
      }

      // ✅ Close modal
      onClose();
    }
  } catch (error) {
    console.error("Error creating subcategory:", error);
    // alert("Failed to create subcategory.");
  } finally {
    setLoading(false);
  }
};


  return (
    <Modal show={show} size="md">
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#b7dfd0' }}>
          <h3 className="modal-title">Create Raw Material Sub Category</h3>
          <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
            <span>×</span>
          </Button>
        </div>

        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Raw Material Category <span className="required">*</span></label>
              <Select
                placeholder='Select Raw Material Category'
                value={selectedOption}
                onChange={setSelectedOption}
                options={categories}
              />
            </div>

            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Raw Material Sub Category<span className="required">*</span></label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Raw Material Sub Category"
                value={subcategoryName}
                onChange={(e) => setSubcategoryName(e.target.value)}
              />
            </div>

            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Description</label>
              <textarea
                rows={4}
                className="form-control"
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
            <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
            <Button
              type="submit"
              className="btn btn-sm btn-primary"
              onClick={handleCreate}
              disabled={loading}
            >
              {loading ? "Saving..." : "Create Raw Material Sub Category"}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddRawMaterialSubCat;
